import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import Access from 'Components/Access';
import Icon from 'Components/Icon';
import { routeUrl } from '~/router';
import { DeleteOrder } from './components';
import type { Tender, Order } from '~/models/tenders';

interface Props {
  tender: Tender;
  order: Order;
}

const itemLinkClass =
  'tw:no-underline tw:text-inherit tw:hover:no-underline tw:hover:text-inherit tw:focus:no-underline tw:focus:text-inherit';

export const OrderActionsMenu = ({ tender, order }: Props) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      aria-label="Order actions"
      className="tw tw:inline-flex tw:items-center tw:justify-center tw:text-gray-500 tw:outline-none tw:hover:text-gray-900 tw:focus:text-gray-900"
    >
      <Icon name="more_horiz" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <Access to="edit" model={order}>
        <DropdownMenuItem asChild>
          <Link
            className={itemLinkClass}
            to={routeUrl('tender-edit-orders', {
              tenderId: tender.id,
              orderId: order.id,
              mode: 'edit',
            })}
          >
            <FormattedMessage
              id="tender-details-order-button-edit"
              defaultMessage="Edit {orderType, select, offer {offer} bid {bid} other {{orderType}}}"
              values={{ orderType: order.ordertype }}
            />
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link
            className={itemLinkClass}
            to={routeUrl('tender-duplicate-order', {
              tenderId: tender.id,
              orderId: order.id,
            })}
          >
            <FormattedMessage
              id="tender-details-order-button-duplicate"
              defaultMessage="Duplicate {orderType, select, offer {offer} bid {bid} other {{orderType}}}"
              values={{ orderType: order.ordertype }}
            />
          </Link>
        </DropdownMenuItem>
      </Access>
      <Access to="delete" model={order}>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <DeleteOrder tender={tender} order={order} menuItem>
            <FormattedMessage
              id="tender-details-order-button-delete"
              defaultMessage="Delete {orderType, select, offer {offer} bid {bid} other {{orderType}}}"
              values={{ orderType: order.ordertype }}
            />
          </DeleteOrder>
        </DropdownMenuItem>
      </Access>
    </DropdownMenuContent>
  </DropdownMenu>
);
